module.exports = {"TXTWCL_Singles":{"id":"TXTWCL_Singles","defaultMessage":"Simples","track":"Singles","ontario":"Paris directs"}}